module.exports = __webpack_public_path__ + "static/offer-brand-basic-3-00344b8ccff99164191e760ba67f623f.jpg";